import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { setOverlayStatus } from "../../Store/LoadReducer";
import { useDispatch } from "react-redux";
import { fileStorage, customAxios, modelPollingPromise } from "../../../helpers/utils";
import { STLLoader } from "three/examples/jsm/loaders/STLLoader";
import * as THREE from "three";


function Handler() {
    const files = useSelector(item => item.flowviewer.files);
    const isFFRCalculated = useSelector(item => item.flowviewer.isFFRCalculated);
    const dispatch = useDispatch();
    const [calculationStatus, setCalculationStatus] = useState(false);

    const calc = async () => {
        const axiosInstance = customAxios();
        const stlPromise = axiosInstance.get("/file/stl/get", { responseType: 'arraybuffer' });
        const coloringPromise = modelPollingPromise("coloring");

        return Promise.all([stlPromise, coloringPromise])
            .then(async responses => {
                await fileStorage.saveFile('stl', responses[0].data);
                const coloring = new Blob(
                    [JSON.stringify(responses[1].data.result)],
                    { type: "application/json" }
                );
                await fileStorage.saveFile('coloring', coloring);
            })
            .catch(e => {
                // TODO: log error
            });
    };

    useEffect(async () => {
        if (
            !files["coloring"] &&
            !calculationStatus &&
            isFFRCalculated
        ) {
            setCalculationStatus(true);
            dispatch(setOverlayStatus("loading"));
            await calc();
            setCalculationStatus(false);
            dispatch(setOverlayStatus(false));
        }
    }, [
        isFFRCalculated,
        files["coloring"]
    ]);

    return (
        <div className="d-none"></div>
    );
}

export default Handler;


